// extracted by mini-css-extract-plugin
export default {"button":"ButtonBlock_button__3wG0Z","root":"ButtonBlock_root__1brXF","left":"ButtonBlock_left__3WbLj","right":"ButtonBlock_right__1EQvK","disabled":"ButtonBlock_disabled__315eR"};